import type { ApiExecutionResult } from '../apiResponse'

/** 機能オプション */
export const FeatureOptions = {
  /** DUP機能 */
  dupAuth: 'DupAuth',
  /** スクリーニング機能 */
  screeningAuth: 'ScreeningAuth',
  /** 固定資産スクリーニング機能 */
  propScrAuth: 'PropScrAuth'
} as const

/** 機能オプション */
export type FeatureOptions = (typeof FeatureOptions)[keyof typeof FeatureOptions]

/** 自治体設定API queryリクエストパラメータ */
export interface QueryParam {
  /** システムID */
  system: string
  /** 自治体コード */
  govCode: string
}

/** queryリザルト */
export interface QueryResponseResult {
  /** システムID */
  system: string
  /** 自治体コード */
  govCode: string
  /** 機能オプション */
  featureOptions?: FeatureOptions[]
}

/** queryレスポンス */
export type QueryResponse = ApiExecutionResult<QueryResponseResult>
